import type { CellColor, CellLayer, Grid } from "../types.ts";

export function createGrid(rows: number, cols: number, colors: CellColor[][] | null = null): Grid {
  const cells: CellLayer[][][] = [];
  for (let r = 0; r < rows; r++) {
    cells[r] = [];
    for (let c = 0; c < cols; c++) {
      const color = colors ? colors[r]![c]! : null;
      cells[r]![c] = [{ color, originalRow: r, originalCol: c }];
    }
  }
  return { rows, cols, cells };
}

export function cloneGrid(grid: Grid): Grid {
  const cells: CellLayer[][][] = [];
  for (let r = 0; r < grid.rows; r++) {
    cells[r] = [];
    for (let c = 0; c < grid.cols; c++) {
      cells[r]![c] = grid.cells[r]![c]!.map((layer) => ({ ...layer }));
    }
  }
  return { rows: grid.rows, cols: grid.cols, cells };
}

export function getTopColor(stack: CellLayer[]): CellColor {
  for (let i = stack.length - 1; i >= 0; i--) {
    if (stack[i]!.color !== null) {
      return stack[i]!.color;
    }
  }
  return null;
}
